export const EmailFieldLabel = ({ children, status = 'optional' }) => {
    const labels = {
        required: 'Necesario',
        recommended: 'Recomendado',
        optional: 'Opcional',
        automatic: 'Automático',
    };

    return (
        <span className="PBMAIL__field_label">
            <span>{children}</span>
            <em className={`PBMAIL__field_status is-${status}`}>{labels[status] || labels.optional}</em>
        </span>
    );
};

export const EmailFieldHint = ({ children }) => (
    <small className="PBMAIL__field_hint">{children}</small>
);
